import { LoaderCircle } from 'lucide-react';
import { Skeleton, Text } from '@/ui/design-system/components';
import { PagePadding } from 'components/PagePadding';
import { WIDGET_GRID_CLASS } from './ReportWidgetGrid';

// Placeholder tiles shaped like the report grid, so the eventual navigation to
// the real report doesn't reflow the page.
const SKELETON_TILES = 3;

// Matches the widget tile's gray frame + min height so a real ReportWidget can
// take its place without the grid jumping.
function SkeletonTile() {
    return (
        <div className="flex min-h-[455px] flex-col gap-4 rounded-xl bg-background-med-em p-4">
            <Skeleton className="h-4 w-1/3" />
            <Skeleton className="flex-1" />
        </div>
    );
}

// A static report-shaped placeholder: the build itself streams in the
// assistant panel, so this page shows the prompt, a status line tied to the
// panel's loading state, and placeholder tiles — nothing live. When the
// assistant finishes the report it navigates here away; when it finishes
// WITHOUT one (error, nothing renderable), the caption points at the panel,
// which explains what happened.
function ReportBuildView({ prompt, isLoading }) {
    return (
        <PagePadding className="flex flex-col gap-14 max-w-[1696px] pt-6">
            <div className="flex flex-col gap-3">
                <div className="max-w-2xl">
                    <div className="inline-block whitespace-pre-wrap rounded-xl rounded-bl-sm bg-secondary px-3.5 py-2.5 text-sm leading-relaxed text-foreground">
                        {prompt}
                    </div>
                </div>
                <div className="flex items-center gap-2 text-muted-foreground">
                    {isLoading && (
                        <LoaderCircle size={14} className="animate-spin" />
                    )}
                    <Text size="sm" color="muted">
                        {isLoading
                            ? 'Spate AI is building your report — follow along in the assistant panel.'
                            : 'Spate AI has finished — see the assistant panel for the outcome.'}
                    </Text>
                </div>
            </div>
            <div className={WIDGET_GRID_CLASS}>
                {Array.from({ length: SKELETON_TILES }).map((_, i) => (
                    <SkeletonTile key={`skeleton-${i}`} />
                ))}
            </div>
        </PagePadding>
    );
}

export default ReportBuildView;
